/* ============
 * Mutation types for the panoramas module
 * ============
 *
 * The mutation types that are available
 * on the panoramas module.
 */

export const LOAD = 'LOAD';

export default {
  LOAD,
};
